import { render, staticRenderFns } from "./injuryAnalysis.vue?vue&type=template&id=b8f9435a&scoped=true&"
import script from "./injuryAnalysis.vue?vue&type=script&lang=js&"
export * from "./injuryAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./injuryAnalysis.vue?vue&type=style&index=0&id=b8f9435a&prod&lang=scss&scoped=true&"
import style1 from "./injuryAnalysis.vue?vue&type=style&index=1&id=b8f9435a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f9435a",
  null
  
)

export default component.exports